import React from "react";
import { Route, Switch } from "react-router-dom";

/**
 * Función que itera todas las rutas disponibles del sistema
 * @export
 * @param {Object[]} { routes } Archivo: /components/config/routes.js
 * @return {*} JSX
 */
export function LoadRoutes({ routes }) {
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          render={(props) => <route.component />}
        />
      ))}
    </Switch>
  );
}
